import RSSFeedInfo from './RSSFeedInfo'
import RSSFeedItem from './RSSFeedItem'
import RSSFeedItems from './RSSFeedItems'
import RSSFeed from './RSSFeed'

const abundanceEngineExports = {
  RSSFeed,
  RSSFeedItems,
  RSSFeedItem,
  RSSFeedInfo
}

export default abundanceEngineExports
